import { BaseModel } from 'src/app/shared/models/base.model';

export class Category extends BaseModel{

    public subcategorias:any;
    
    static fromJsonToObject(jsonData:any):Category{
        return Object.assign(new Category(),jsonData);
    }
}